export const ERR_NETWORK = 'ERR_NETWORK';
export const GENDER = [
  { label: 'Мужской', value: 'MALE' },
  { label: 'Женский', value: 'FEMALE' },
];

// lodash
export const DEBOUNCE_WAIT = 900;
// primereact
export const TOAST_LIFE = 3000;
export const DEFAULT_PAGE_INDEX = '1';
// project fields
export const MIN_LENGTH_DATE = 1;
export const LOGIN_MAX_LENGTH = 150;
export const PIN_CODE_MAX_LENGTH = 3;
export const GLUCOMETER_SERIAL_NUMBER = 11;
export const AGE_MIN_VALUE = 0;
export const AGE_MAX_VALUE = 200;
export const OBSERVERS_MAX_VALUE = 100;
